// import { useState } from 'react';
import { useRouter } from 'next/router';
import { basePageWrap } from '../BasePage';
import { BlogPost, PostModal } from '../../components/Blog';

function BlogPage({ title, blogIntro, posts, postSlug }) {
    const router = useRouter();
    // const currentPageSlug = router.asPath;

    const openPost = (post) => {
        router.push(post.htmlUrl); // navigate to the post page
    };

    const closePost = () => {
        router.push('/blog');
    };

    const currentPost = posts.find(post => post.htmlUrl.split('/').filter(Boolean).pop() === postSlug);

    return (
        <section className='w-full'>
            <div className='container-main'>
                <h1 className="text-vw-8xl font-bold sm:whitespace-pre-wrap">{title}</h1>
                <div className='sm:text-vw-3xl text-vw-5xl mb-vw-4'>{blogIntro && <div dangerouslySetInnerHTML={{ __html: blogIntro }} />}</div>
            </div>
            <div className='container-main sm:px-vw-7 relative'>
                <div className='blog-posts flex flex-col gap-12 mt-16'>
                    {posts.map((post, id) => (
                            <BlogPost key={id} post={post} openPost={() => openPost(post)} className={ (id % 2) ? 'even' : 'odd' } />
                        )
                    )}
                </div>
            {postSlug && <PostModal post={currentPost} closePost={closePost} />}
            </div>
        </section>
    );
}

export default basePageWrap(BlogPage);